import { store } from '@betacrew/jars-flux'
export const componentKey = "API";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setSandBoxAppKey: (state, action) => {
            state.sandBoxAppKey = action.payload;
        },
        setProductionAppKey: (state, action) => {
            state.productionAppKey = action.payload;
        },
        setIsMndaSigned: (state, action) => {
            state.isMndaSigned = action.payload;
        },
        setShowProdAppKey: (state, action) => {
            state.showProdAppKey = action.payload;
        },
        setUserType: (state, action) => {
            state.userType = action.payload;
        },
        setApiPortalLoginUrl: (state, action) => {
            state.apiPortalLoginUrl = action.payload;
        },
        setSandBoxApplicationUrl: (state, action) => {
            state.sandBoxApplicationUrl = action.payload;
        },
        setIsRequestedProductionAppKey: (state, action) => {
            state.isRequestedProductionAppKey = action.payload;
        }, 
        setRowsPerPage: (state, action) => {
            state.rowsPerPage = action.payload;
        }, 
        setSkip: (state, action) => {
            state.skip = action.payload;
        }, 
        setDeveloperData: (state, action) => {
            state.developerData = action.payload;
        }, 
        setTotalDeveloper: (state, action) => {
            state.totalDeveloper = action.payload;
        }, 
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        }, 
        setShowInvitePopup: (state, action) => {
            state.showInvitePopup = action.payload;
        }, 
        setIsActive: (state, action) => {
            state.isActive = action.payload;
        }, 
        setShouldProductionKeyRequestManually: (state, action) => {
            state.shouldProductionKeyRequestManually = action.payload;
        }, 
    },
    initialReducerState: {
        sandBoxAppKey: '',
        productionAppKey: '',
        isMndaSigned: null,
        isActive: false,
        showProdAppKey: false,
        userType: 0,
        apiPortalLoginUrl: '',
        sandBoxApplicationUrl: '',
        isRequestedProductionAppKey: '',
        skip: 0,
        rowsPerPage: 10,
        developerData: [],
        totalDeveloper: 1,
        loadingState: false,
        showInvitePopup: false,
        shouldProductionKeyRequestManually: false,
    }
});
export const { setLoadingState, setShowInvitePopup, setTotalDeveloper, setDeveloperData, setRowsPerPage, setSkip, setIsRequestedProductionAppKey, setSandBoxAppKey, setProductionAppKey, setIsMndaSigned, setShowProdAppKey, setUserType, setApiPortalLoginUrl, setSandBoxApplicationUrl, setIsActive, setShouldProductionKeyRequestManually } = actions;